// STICKY HEADER
const header = document.querySelector(".header-section");

window.addEventListener(
  "scroll",
  () => {
    header?.classList.toggle("sticky-header", window.scrollY > 10);
  },
  { passive: true }
);

// SEARCH DRAWER
// FETCH SEARCH RESULSTS AND RENDER IN SEARCH DRAWER
class HeaderSearch extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.input = this.querySelector("#main_header_search_input");
    this.mainWrapper = this.querySelector(".main_header_search_header");
    this.wrapper = this.querySelector(".main_header_search_results");
    this.emptySearch = this.querySelector(".main_header_search_empty_wrapper");
    this.h2 = this.mainWrapper.querySelector("h2");

    if (this.input) {
      this.input.addEventListener(
        "input",
        this.debounce(() => this.fetchSuggestions(), 500)
      );
    } else {
      console.error("Search input not found");
    }
  }

  debounce(func, delay) {
    let timeout;
    return (...args) => {
      clearTimeout(timeout);
      timeout = setTimeout(() => func.apply(this, args), delay);
    };
  }

  fetchSuggestions() {
    const query = this.input.value.trim();
    if (query.length === 0) {
      this.clearResults();
      this.emptySearch.style.display = "block";
      return;
    }

    fetch(
      `${window.Shopify.routes.root}search/suggest.json?q=${query}&resources[type]=product,collection,article`
    )
      .then((response) => response.json())
      .then(({ resources }) => this.renderResults(resources.results))
      .catch((error) => console.error("Error fetching suggestions:", error));
  }

  renderResults(results) {
    let productLength = results.products.length;
    let collectionLength = results.collections.length;
    let articleLength = results.articles.length;

    // Clear previous results
    this.mainWrapper.innerHTML = "";
    this.wrapper.innerHTML = ""; // Clear previous search results

    if (productLength > 0) {
      const productHeader = document.createElement("button");
      productHeader.textContent = `Products (${productLength})`;
      productHeader.classList.add(
        "active",
        "scroll-trigger",
        "animate--slide-in"
      );
      this.mainWrapper.appendChild(productHeader);

      const productWrapper = document.createElement("div");
      productWrapper.classList.add("product-wrapper");

      let products = results.products;
      products.forEach((product, i) => {
        let money_format = document
          .querySelector(".header_wrapper")
          .getAttribute("data-money-format");
        let price = Shopify.formatMoney(product.price_min, money_format);
        let cap_price = Shopify.formatMoney(
          product.compare_at_price_min,
          money_format
        );
        let pro = `
          <div class="header_search_product-card scroll-trigger animate--slide-in" 
          data-cascade
          style="--animation-order: ${i} "
          >
            <div class="header_search_product_card_img ratio">              
                <a aria-label="${product.title}" tabindex="1" href="${product.url}"><img src="${product.featured_image.url}" alt="${product.title}"/></a>
            </div>
            <div class="header_search_product_card_info">
            <h3><a aria-label="${product.title}" href="${product.url}">${product.title}</a></h3> 
            <div class="header_search_product_card_price_wrapper">
              <p data-cap="${product.compare_at_price_min}" class="cap_price">${cap_price}</p>
              <p class="og_price">${price}</p>            
            </div>
            </div>
          </div>`;

        productWrapper.innerHTML += pro;
      });

      this.wrapper.appendChild(productWrapper);
      this.emptySearch.style.display = "none";
    }

    if (collectionLength > 0) {
      const collectionHeader = document.createElement("button");
      collectionHeader.textContent = `Collections (${collectionLength})`;
      if (productLength === 0 && articleLength === 0) {
        collectionHeader.classList.add(
          "active",
          "scroll-trigger",
          "animate--slide-in"
        );
      } else {
        collectionHeader.classList.add("scroll-trigger", "animate--slide-in");
      }
      this.mainWrapper.appendChild(collectionHeader);

      const collectionWrapper = document.createElement("div");
      if (productLength === 0 && articleLength === 0) {
        collectionWrapper.classList.add("collection-wrapper");
        collectionWrapper.querySelectorAll('a, input, button').forEach((el) => {
          el.setAttribute('tabindex', '0')
        })
      } else {
        collectionWrapper.classList.add("nodisp", "collection-wrapper");
        collectionWrapper.querySelectorAll('a').forEach((el) => {
          el.setAttribute('tabindex', '-1')
        })
      }

      let collections = results.collections;
      collections.forEach((collection, i) => {
        let coll = `
          <div class="header_search_collection-card scroll-trigger animate--slide-in" 
          data-cascade
          style="--animation-order: ${i} "
          >            
            <h3><a tabindex="-1" aria-label="${collection.title}" href="${collection.url}">${collection.title}</a></h3>            
          </div>`;

        collectionWrapper.innerHTML += coll;
      });

      this.wrapper.appendChild(collectionWrapper);
      this.emptySearch.style.display = "none";
    }

    if (articleLength > 0) {
      const articleHeader = document.createElement("button");
      articleHeader.textContent = `Articles (${articleLength})`;
      if (productLength === 0 && collectionLength === 0) {
        articleHeader.classList.add(
          "active",
          "scroll-trigger",
          "animate--slide-in"
        );
      } else {
        articleHeader.classList.add("scroll-trigger", "animate--slide-in");
      }
      this.mainWrapper.appendChild(articleHeader);

      const articleWrapper = document.createElement("div");
      if (productLength === 0 && collectionLength === 0) {
        articleWrapper.classList.add("article-wrapper");
      } else {
        articleWrapper.classList.add("nodisp", "article-wrapper");
      }

      let articles = results.articles;
      articles.forEach((article, i) => {
        let art = `
          <div class="header_search_article-card scroll-trigger animate--slide-in" 
          data-cascade
          style="--animation-order: ${i} "
          >
            <div class="header_search_article_card_img ratio">              
                <a tabindex="-1" aria-label="${article.url}" href="${article.url}"><img src="${article.featured_image.url}" alt="${article.title}"/></a>
            </div>
            <div class="header_search_article_card_info">
            <h3><a tabindex="-1" aria-label="${article.url}" href="${article.url}">${article.title}</a></h3>            
            <p class="header_search_article_author">Author: ${article.author}</p>
            </div>
          </div>`;

        articleWrapper.innerHTML += art;
      });

      this.wrapper.appendChild(articleWrapper);
      this.emptySearch.style.display = "none";
    }

    if (productLength === 0 && collectionLength === 0 && articleLength === 0) {
      const emptyHeader = document.createElement("h2");
      emptyHeader.textContent = "No results found.";
      emptyHeader.classList.add(
        "active",
        "scroll-trigger",
        "animate--slide-in",
        "no_cursor"
      );
      this.mainWrapper.appendChild(emptyHeader);
      this.emptySearch.style.display = "none";
    }

    let headings = this.mainWrapper.querySelectorAll("button");
    let productWrapper = this.wrapper.querySelector(".product-wrapper");
    let collectionWrapper = this.wrapper.querySelector(".collection-wrapper");
    let articleWrapper = this.wrapper.querySelector(".article-wrapper");
    this.handleClick(
      headings,
      productWrapper,
      collectionWrapper,
      articleWrapper
    );
  }

  clearResults() {
    this.mainWrapper.innerHTML = "";
    this.wrapper.innerHTML = "";
  }

  handleClick(headings, productWrapper, collectionWrapper, articleWrapper) {
    headings.forEach((heading) => {
      heading.addEventListener("click", () => {
        headings.forEach((h) => h.classList.remove("active"));
        heading.classList.add("active");
        let head = heading.textContent;
        if (head.includes("Articles")) {
          articleWrapper.classList.remove("nodisp");
          articleWrapper.querySelectorAll('a, input, button').forEach((el) => {
            el.setAttribute('tabindex', '0')
          })
          if (productWrapper != null) {
            productWrapper.classList.add("nodisp");
            productWrapper.querySelectorAll('a, input, button').forEach((el) => {
              el.setAttribute('tabindex', '-1')
            })
          }
          if (collectionWrapper != null) {
            collectionWrapper.classList.add("nodisp");
            collectionWrapper.querySelectorAll('a, input, button').forEach((el) => {
              el.setAttribute('tabindex', '-1')
            })
          }
        } else if (head.includes("Products")) {
          productWrapper.classList.remove("nodisp");
          productWrapper.querySelectorAll('a, input, button').forEach((el) => {
              el.setAttribute('tabindex', '0')
            })
          if (articleWrapper != null) {
            articleWrapper.classList.add("nodisp");
            articleWrapper.querySelectorAll('a, input, button').forEach((el) => {
              el.setAttribute('tabindex', '-1')
            })
          }
          if (collectionWrapper != null) {
            collectionWrapper.classList.add("nodisp");
            collectionWrapper.querySelectorAll('a, input, button').forEach((el) => {
              el.setAttribute('tabindex', '-1')
            })
          }
        } else if (head.includes("Collections")) {
          collectionWrapper.classList.remove("nodisp");
          collectionWrapper.querySelectorAll('a, input, button').forEach((el) => {
              el.setAttribute('tabindex', '0')
            })
          if (articleWrapper != null) {
            articleWrapper.classList.add("nodisp");
            articleWrapper.querySelectorAll('a, input, button').forEach((el) => {
              el.setAttribute('tabindex', '-1')
            })
          }
          if (productWrapper != null) {
            productWrapper.classList.add("nodisp");
            productWrapper.querySelectorAll('a, input, button').forEach((el) => {
              el.setAttribute('tabindex', '-1')
            })
          }
        }
      });
    });
  }
}

customElements.define("header-search", HeaderSearch);

// SEARCH DRAWER SLIDER
var swiper = new Swiper(".main_header_search_help_collection_wrapper", {
  slidesPerView: 2.2,
  spaceBetween: 15,
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
});

// MOBILE MENU DRAWER
function slideDown(el) {
  el.style.maxHeight = el.scrollHeight + "px";

  requestAnimationFrame(() => {
    const parentAccordion = el.closest(".main-accordion-content");
    if (parentAccordion) {
      parentAccordion.style.maxHeight =
        parentAccordion.scrollHeight + el.scrollHeight + "px";
      console.log(parentAccordion.style.maxHeight);
    }
  });
}

function slideUp(el) {
  el.style.maxHeight = "0";

  requestAnimationFrame(() => {
    const parentAccordion = el.closest(".accordion-content");
    if (parentAccordion && parentAccordion !== el) {
      parentAccordion.style.maxHeight = parentAccordion.scrollHeight + "px";
    }
  });
}

function closeSiblings(currentToggle) {
  const parentWrapper =
    currentToggle.closest(".accordion-wrapper") ||
    currentToggle.parentElement.parentElement;
  const allToggles = parentWrapper.querySelectorAll(".accordion-toggle");

  allToggles.forEach((toggle) => {
    if (toggle === currentToggle) return;

    const content = toggle.nextElementSibling;
    if (content?.classList.contains("accordion-content")) {
      toggle.classList.remove("active");
      toggle.querySelector?.(".plus_vertical")?.classList.remove("rot");
      slideUp(content);
    }
  });
}

document.querySelectorAll(".accordion-toggle button").forEach((toggle) => {
  toggle.addEventListener("click", () => {
    const content = toggle.closest(".accordion-toggle").nextElementSibling;
    const isOpen = toggle
      .closest(".accordion-toggle")
      .classList.contains("active");
    const plus = toggle
      .closest(".accordion-toggle")
      .querySelector?.(".plus_vertical");

    closeSiblings(toggle.closest(".accordion-toggle"));

    if (content?.classList.contains("accordion-content")) {
      toggle.closest(".accordion-toggle").classList.toggle("active", !isOpen);
      plus?.classList.toggle("rot", !isOpen);

      if (isOpen) {
        slideUp(content);
      } else {
        slideDown(content);
      }
    }
  });


  toggle.addEventListener('focusin', (e) => {
    const el = e.target;
    if(el.matches(':focus-visible')) {
      const content = toggle.closest(".accordion-toggle").nextElementSibling;
      const isOpen = toggle
        .closest(".accordion-toggle")
        .classList.contains("active");
      const plus = toggle
        .closest(".accordion-toggle")
        .querySelector?.(".plus_vertical");

      closeSiblings(toggle.closest(".accordion-toggle"));

      if (content?.classList.contains("accordion-content")) {
        toggle.closest(".accordion-toggle").classList.toggle("active", !isOpen);
        plus?.classList.toggle("rot", !isOpen);

        if (isOpen) {
          slideUp(content);
        } else {
          slideDown(content);
        }
      }
    }
  })
});
